import { render, staticRenderFns } from "./LawCard.vue?vue&type=template&id=22641f82&scoped=true&"
import script from "./LawCard.vue?vue&type=script&lang=js&"
export * from "./LawCard.vue?vue&type=script&lang=js&"
import style0 from "./LawCard.vue?vue&type=style&index=0&id=22641f82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22641f82",
  null
  
)

export default component.exports